export const GET_LONG_TERM_STAT = 'stat/GET_LONG_TERM_STAT';
export const SET_LONG_TERM_STAT = 'stat/SET_LONG_TERM_STAT';
export const UPDATE_STAT_STARTED = 'stat/UPDATE_STAT_STARTED';
export const UPDATE_STAT_FAILURE = 'stat/UPDATE_STAT_FAILURE';
export const SET_INITIAL_STAT = 'stat/SET_INITIAL_STAT';
export const UPDATE_GAME_STAT = 'stat/UPDATE_GAME_STAT';
export const SET_GAME_STAT = 'stat/SET_GAME_STAT';
